export const PUB_LEARNING_STYLE = 'pub_learningStyle';
export const PUB_URGENCY_LEVEL = 'pub_urgencyLevel';
export const FAQ = 'faq';
export const BOOKING_LEAD_TIME = 'bookingLeadTime';
export const TIME_ZONE_FIELD = 'timeZone';
export const CANCELLATION_POLICY_FIELD = 'cancellationPolicy';
export const LISTING_TITLE = 'listingTitle';
export const TUTOR_ACEDEMIC_DISCPLINE = 'tutorAcademicDisciplines';
export const STUDENT_ACADEMIC_DISCIPLINE = 'pub_academicDisciplines';
export const STUDENT_COURSE_TOPIC = 'courseTopic';
export const STUDENT_LEARNING_STYLE = 'pub_learningStyle';
export const STUDENT_ABOUT_US = 'aboutUs';
export const STUDENT_TIME_ZONE = 'timeZone';
export const STRIPE_ADDRESS_LINE_1 = 'addressLine1';
export const STRIPE_ADDRESS_LINE_2 = 'addressLine2';
export const POSTAL = 'postal';
export const CITY = 'city';
export const STATE = 'state';
export const COUNTRY = 'country';
export const NAME = 'name';
export const YEAR_FITLER = "publicData.tutorExperience";
export const CUSTOM = "custom";
export const STATIC_ARRAY_OF_10 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
export const OFFER_FREE_CONSULTATIONS = 'publicData.offerFreeConsultations';
export const YES = "Yes";
export const NO = "No";
export const FALSE = "false";
export const LESS_THAN_A_YEAR = "lessThanYear";
export const MORE_THAN_10 = "moreThanTen";
export const STUDENT_ACADEMIC_DISPLINE_CUSTOM_FIELD = "academicDisciplinesCustom";
export const TRANSACTION_PAGE = 'transactionPage';
export const SESSION_LINK = 'sessionLink';
export const DEFAULT_BOOKING = 'default-booking/release-1';
export const DEFAULT_FREE_BOOKING = 'default-free-booking/release-1';
export const DEFAULT_STUDENT_OFFER = 'default-student-offer/release-1'
export const DEFAULT_PAYMENT = 'default-payment/release-1';
export const DEFAULT_INQUIRY = 'default-inquiry/release-1';
export const DEFAULT_STUDENT_PROCESS = 'default-student-offer/release-1 ';
export const INQUIRY = "inquiry";
export const INQUIRY_STUDENT = "inquiry-student";
export const REQUEST_STUDENT = 'requestStudent';
export const REQUEST_TUTOR = 'requestTutor';
export const INQUIRY_TUTOR = "inquiry-tutor";
export const INQUIRE_TRANSITION = 'transition/inquire';
export const REQUEST_TRANSITION = 'transition/request-student-offer';